"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_init_1 = require("./modules/swiper-init");
const header_1 = require("./modules/header");
const height_equalizer_1 = require("./modules/height-equalizer");
const scrollTo_1 = require("./modules/scrollTo");
const io_1 = require("./modules/io");
document.addEventListener('DOMContentLoaded', () => {
    // Initialize all modules
    (0, io_1.io)();
    (0, swiper_init_1.initSwipers)();
    (0, header_1.initHeader)();
    (0, height_equalizer_1.initHeightEqualizer)();
    (0, scrollTo_1.scrollTo)();
});
